import axios from "axios";

// Base URL for your backend
const BASE_URL = process.env.REACT_APP_API_URL || "https://bookingdemoapi.aimpointventures.my";
// const BASE_URL = process.env.REACT_APP_API_URL || "https://venue-api.aimpointventures.my";
// const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:9000";

// Each app should send its appId + secretKey
const APP_ID = process.env.REACT_APP_APP_ID || "ap001";
const APP_SECRET = process.env.REACT_APP_APP_SECRET || "UBZUz4ytDupTzncRyQerMsuLRKAtcxQJ";

// Create Axios instance
const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "x-app-id": APP_ID,
    "x-app-secret": APP_SECRET,
  },
});

// Request interceptor: attach JWT if exists
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("cvToken");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor: global error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Optionally handle token expiration, logout, etc.
    if (error.response && error.response.status === 401) {
      // Token expired or unauthorized
      localStorage.removeItem("cvToken");
      window.location.href = "/login"; // redirect to login
    }
    return Promise.reject(error);
  }
);

export default api;